import { useState } from "react";
import { doc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import { updateDoc } from "./auditedFirestore";
import { auditFetch } from "./auditActivity";
export default function BookingWorkflowActions({ booking, notify, style }) {
  const [busy, setBusy] = useState(false);
  const run = async (action) => {
    setBusy(true);
    try {
      if (action === "kitchen") {
        await updateDoc(doc(db,"bookings",booking.id), {status:"sent_to_kitchen",sentToKitchenAt:serverTimestamp()});
        notify("Sent to kitchen; invoice generation will follow.");
      } else {
        const response = await auditFetch(action === "invoice" ? "/xeroRetryInvoice" : "/xeroRetryEmail", {method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({bookingId:booking.id})});
        const result = await response.json();
        if (!response.ok) throw Error(result.error || "The request failed.");
        notify(result.message || "Completed");
      }
    } catch (error) { notify(error.message || "Please try again.", "error"); }
    finally { setBusy(false); }
  };
  return <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:8}}>
    {booking.status === "confirmed" && <button style={style} disabled={busy} onClick={()=>run("kitchen")}>Send to kitchen</button>}
    {booking.status === "sent_to_kitchen" && !booking.xeroInvoiceId && <button style={style} disabled={busy} onClick={()=>run("invoice")}>{busy ? "Generating…" : booking.xeroError ? "Retry invoice" : "Generate invoice"}</button>}
    {booking.xeroInvoiceId && !booking.xeroEmailSent && <button style={style} disabled={busy} onClick={()=>run("email")}>{busy ? "Sending…" : "Send invoice email"}</button>}
  </div>;
}
